"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    .MuiInputBase-root {\n      input {\n        padding: ", " ", ";\n        height: 1rem;\n      }\n\n      textarea {\n        padding: 0px;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TextField = (0, _styledComponents["default"])(_TextField["default"])(_templateObject(), _spacing["default"][3], _spacing["default"][4]);
exports.TextField = TextField;